$(function () {
    $(".certificate-form .brand select option[value='none']").hide();
    $(".certificate-form .metal select option[value='none']").hide();

    $(".certificate-form .mount").on("change", "input", function () {
        var mount = $("input[name='mount']:checked").val();

        if (mount == "nomount1") {
            $(".metal select option").hide();
            $(".metal select option[value='none']").show();
            $(".metal select").val("none");

            $(".brand select option").hide();
            $(".brand select option[value='none']").show();
            $(".brand select").val("none");
        } else {
            if ($(".metal select").val() == "none") {
                $(".metal select option").show();
                $(".metal select option[value='none']").hide();
                $(".metal select option:selected").prop("selected", false);
            }
            if ($(".brand select").val() == "none") {
                $(".brand select option").show();
                $(".brand select option[value='none']").hide();
                $(".brand select option:selected").prop("selected", false);
            }
        }
    });

    $(".certificate-form .brand_other").hide();
    $(".certificate-form .brand").on("change", "select", function () {
        var brand = $(this).children("option:selected").val();

        if (brand == "Other") {
            $(".brand_other").show().addClass("required");
        } else {
            $(".brand_other").hide().removeClass("required");
        }
    });
});
